import i18next from 'i18next';
import Swal from 'sweetalert2';
import gifUrl from '../assets/images/error.gif';
import { ApiError } from './api/ApiError';

const getTranslation = (key: string, namespace: string, options?: any): string | null => {
    const text: string = i18next.t(`${namespace}:${key}`, options).toString();

    return text.startsWith('utils') ? key : text.toString();
};
const createHtmlContent = (error: ApiError, message: string) => {
    const kibanaUrl = `https://my-deployment-77f6f1.kb.ap-south-1.aws.elastic-cloud.com/app/discover#/?_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:5000),time:(from:now-15h,to:now))&_a=(columns:!(reqId,logLevel,serviceName,msg,clientId,userEmail,message),dataSource:(dataViewId:'1b0db51b-ebe0-4ba3-952d-5d7007effdf0',type:dataView),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'1b0db51b-ebe0-4ba3-952d-5d7007effdf0',key:reqId,negate:!f,params:(query:${error.reqId}),type:phrase),query:(match_phrase:(reqId:${error.reqId})))),grid:(columns:(logLevel:(width:66),msg:(width:354),reqId:(width:107),serviceName:(width:85))),interval:auto,query:(language:kuery,query:''),sort:!(!('@timestamp',desc)))`;
    return `
    <div style="text-align: left;">
        <p class="fw-bold" style="font-size: 20px;">${message.split('\n')[0]}</p>
        ${message
            .split('\n')
            .slice(1)
            .map((line) => `<div style="font-size: 14px;">${line}</div>`)
            .join('')}
    </div>
    <div style="text-align: left; font-size: 15px; color: #007bff; margin-top: 10px">
        <a href="${kibanaUrl}" target="_blank">View in Kibana</a>
    </div>
    <button id="copy-button" class="swal2-styled swal2-confirm" style="margin-top: 20px;">
        <i class="fa fa-copy"></i> Copy error data
    </button>
`;
};

const copyToClipboard = (message: string) => {
    navigator.clipboard
        .writeText(message)
        .then(() => {
            const copyButton: any = document.getElementById('copy-button');
            if (copyButton) {
                copyButton.innerHTML = '<i class="fa fa-check"></i> Copied!';
                copyButton.disabled = true;
            }
        })
        .catch((err) => {
            console.error('Could not copy text: ', err);
        });
};

const getErrorMessage = (error: any) => {
    if (error instanceof ApiError) {
        const kibanaUrl = `https://my-deployment-77f6f1.kb.ap-south-1.aws.elastic-cloud.com/app/discover#/?_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:5000),time:(from:now-15h,to:now))&_a=(columns:!(reqId,logLevel,serviceName,msg,clientId,userEmail,message),dataSource:(dataViewId:'1b0db51b-ebe0-4ba3-952d-5d7007effdf0',type:dataView),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'1b0db51b-ebe0-4ba3-952d-5d7007effdf0',key:reqId,negate:!f,params:(query:${error.reqId}),type:phrase),query:(match_phrase:(reqId:${error.reqId})))),grid:(columns:(logLevel:(width:66),msg:(width:354),reqId:(width:107),serviceName:(width:85))),interval:auto,query:(language:kuery,query:''),sort:!(!('@timestamp',desc)))`;
        const parts = [
            getTranslation(error.message, 'utils'),
            error.status && `Status: ${error.status}`,
            error.errorCode && `Error Code: ${error.errorCode}`,
            error.reqId && `Request ID: <a href="${kibanaUrl}" target="_blank">${error.reqId}</a>`,
            error.serviceName && `Service Name: ${error.serviceName}`,
            error.extraData && `Extra Data: ${JSON.stringify(error.extraData)}`,
        ].filter(Boolean);
        return parts.join('\n');
    } else {
        return `${JSON.stringify(error) === '{}' ? error : JSON.stringify(error)}`;
    }
};

const getErrorContent = (error: any, message: string) => {
    if (error instanceof ApiError) {
        return createHtmlContent(error, message);
    } else {
        return `
            <div style="text-align: left;">
                <p class="fw-bold" style="font-size: 20px;">Error</p>
                <div style="font-size: 14px;">${message}</div>
            </div>
            <button id="copy-button" class="swal2-styled swal2-confirm" style="margin-top: 20px;">
                <i class="fa fa-copy"></i> Copy error data
            </button>
        `;
    }
};

const globalErrorHandler = (error: any) => {
    console.trace('Error', error);
    const message = getErrorMessage(error);
    const content = getErrorContent(error, message);

    if (error.status === 401) {
        try {
            const currentPath = window.location.pathname + window.location.search;
            if (!currentPath.startsWith('/auth/') && !localStorage.getItem('redirectAfterLogin')) {
                localStorage.setItem('redirectAfterLogin', currentPath);
            }
        } catch (e) {
            console.warn('Failed to store redirect URL:', e);
        }

        window.location.href = '/auth/logout';
        return;
    }

    Swal.fire({
        html: content,
        imageUrl: gifUrl,
        imageWidth: 100,
        imageHeight: 100,
        imageAlt: 'Error image',
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
            const copyButton = document.getElementById('copy-button');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    copyToClipboard(message);
                });
            }
        },
        showCloseButton: true,
        closeButtonHtml: '&times;',
    });
};

export default globalErrorHandler;
